<template>
  <div>
    <v-list class="pa-0">
      <v-list-item-group class="transparent">
        <template v-for="({ text, value }, i) in personTypeList">
          <v-list-item :key="text" :to="{ name: 'PersonListByPosition', params: { position: value } }">
            <v-list-item-content>
              <v-list-item-title class="primary--text" v-text="text"></v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>

          <v-divider v-if="i !== personTypeList.length - 1" :key="text + 'divider'"></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "PersonList",
  data() {
    return {
      personTypeList: [
        { text: "Chairperson", value: "chair" },
        { text: "Moderator", value: "moderator" },
        { text: "Judge", value: "judge" },
        { text: "Commentator", value: "commentator" },
        { text: "Speaker", value: "speaker" },
        { text: "Presenter", value: "presenter" }
      ]
    };
  }
};
</script>

<style></style>
